import flatpickr from "flatpickr/dist/esm";
import { _ } from "~/route/globals";
import { node } from "~/util/dom";

export default class ParamsItemDatetime {
	_input: HTMLInputElement;

	_date: Date;

	_calendar: ReturnType<flatpickr>;

	constructor() {
		this._input = node("input", { className: "datetime", placeholder: `${_("route.form.today")}, ${_("route.form.now")}`, value: "", size: 16, type: "text" });
		this._date = new Date();
		this._build();
	}

	destroy() {
		this._calendar.destroy();
		this._calendar = null;
	}

	get input() {
		return this._input;
	}

	get date() {
		return this._input.value ? this._date : null;
	}

	set state(value) {
		const datetime = value ? new Date(value) : new Date();

		this._date = datetime;
		value && this._calendar?.setDate(datetime);
	}

	async _build() {
		let LANG = null;

		if (Userweb.defaultLang !== "en") {
			LANG = await import(/* webpackChunkName: "flatpickrLang" */ `flatpickr/dist/esm/l10n/${Userweb.defaultLang}`);
		}

		this._calendar = flatpickr(this._input, {
			enableTime: true,
			dateFormat: "d.m.Y H:i",
			disableMobile: true,
			position: "below center",
			positionElement: this._input,
			// eslint-disable-next-line camelcase
			time_24hr: true,
			monthSelectorType: "static",
			allowInput: true,
			...LANG? { locale: LANG.default[Userweb.defaultLang] } : {},
			defaultHour: this._date.getHours(),
			defaultMinute: this._date.getMinutes(),
			onChange: (selectedDates: Array<Date>) => {
				this._date = selectedDates[0];
			},
			onClose: () => {
				this._input.dispatchEvent(new CustomEvent("pubt-datetime-change"));
			},
		});
	}
}
